/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
setTimeout(function(){
  const el = document.querySelector('[data-v-714fdf43] span');
  el.innerHTML = "Is this a gift? Write a note here";
}, 2000)


